const Footer = ()=>{
    return(
        <footer className="bg-white border-t border-gray-100">
            <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row justify-between gap-6 items-start">
            <div>
                <div className="text-xl font-semibold text-indigo-600">JustBooked</div>
                <p className="mt-2 text-sm text-gray-600 max-w-xs">The simplest way to manage bookings, staff, and customers for your car wash.</p>
            </div>

            <div className="flex gap-8">
                <div>
                <h4 className="text-sm font-semibold text-gray-900">Product</h4>
                <ul className="mt-3 space-y-2 text-sm text-gray-600">
                    <li><a href="/" className="hover:text-indigo-600">Features</a></li>
                    <li><a href="/subscription-plans" className="hover:text-indigo-600">Pricing</a></li>
                    <li><a href="/sign-up" className="hover:text-indigo-600">Sign Up</a></li>
                </ul>
                </div>

                <div>
                <h4 className="text-sm font-semibold text-gray-900">Company</h4>
                <ul className="mt-3 space-y-2 text-sm text-gray-600">
                    <li><a href="/contact-us" className="hover:text-indigo-600">About</a></li>
                    <li><a href="/contact-us" className="hover:text-indigo-600">Contact</a></li>
                    <li><a href="/contact-us" className="hover:text-indigo-600">Privacy</a></li>
                </ul>
                </div>
            </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-4 border-t border-gray-100 text-sm text-gray-500">
            © {new Date().getFullYear()} JustBooked. All rights reserved.
            </div>
        </footer>
    )
}

export default Footer